




















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ComponentValue extends Vue {
  @Prop() text: string
  @Prop() html: string
  @Prop({ required: false }) cl: string
  @Prop({ required: false }) type: string
  @Prop() bold: boolean
}
